/* ============================================================
   Carrousels mobiles — 2026-08-23
   ------------------------------------------------------------
   Un seul script pour tous les rails marques [data-mcar] :
   grille de photos, videos UGC, cartes « Pourquoi ca marche ».
   Le defilement lui-meme est du CSS pur (scroll-snap, voir
   mobile-fixes.css) ; ce fichier n ajoute que les puces de
   position, qui ne peuvent pas se faire sans JS.

   Choix de conception :
   - la puce active se deduit de la PROGRESSION du defilement
     (scrollLeft / defilement total), pas de la vignette la plus
     proche du centre. Quand plusieurs vignettes tiennent a
     l ecran, « la plus centree » designe deja la 2e alors qu on
     n a pas bouge, et les dernieres ne peuvent jamais etre
     centrees : la premiere et la derniere puce seraient
     inatteignables. La progression, elle, va toujours de la
     premiere puce a la derniere.
   - au-dela de 6 vignettes les puces deviennent illisibles : on
     ne les cree pas, le debord de la vignette suivante suffit a
     signaler qu on peut faire defiler.
   - un rail decoratif (aria-hidden) recoit des puces elles aussi
     masquees aux lecteurs d ecran et hors du parcours clavier :
     elles ne doivent pas exposer un contenu que la page declare
     ignorable.
   ============================================================ */
(function () {
  var rails = document.querySelectorAll('[data-mcar]');
  if (!rails.length) return;

  Array.prototype.forEach.call(rails, function (rail) {
    var items = Array.prototype.slice.call(rail.children);
    if (items.length < 2 || items.length > 6) return;

    var decorative = rail.getAttribute('aria-hidden') === 'true';
    var dots = document.createElement('div');
    dots.className = 'mcar-dots';
    if (decorative) dots.setAttribute('aria-hidden', 'true');

    var buttons = items.map(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mcar-dot';
      if (decorative) {
        b.tabIndex = -1;
      } else {
        b.setAttribute('aria-label', 'Element ' + (i + 1) + ' sur ' + items.length);
      }
      b.addEventListener('click', function () {
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 0) return;
        var left = max * (i / (items.length - 1));
        if (rail.scrollTo) rail.scrollTo({ left: left, behavior: 'smooth' });
        else rail.scrollLeft = left;
      });
      dots.appendChild(b);
      return b;
    });

    rail.parentNode.insertBefore(dots, rail.nextSibling);

    var pending = 0;
    function sync() {
      pending = 0;
      var max = rail.scrollWidth - rail.clientWidth;
      var active = max <= 0 ? 0 : Math.round((rail.scrollLeft / max) * (items.length - 1));
      buttons.forEach(function (b, i) {
        b.classList.toggle('is-active', i === active);
      });
    }

    rail.addEventListener('scroll', function () {
      if (pending) return;
      pending = window.requestAnimationFrame ? requestAnimationFrame(sync) : setTimeout(sync, 60);
    }, { passive: true });

    sync();
  });
})();
